import TruckService from "./TruckService";

class OrderService extends TruckService {

    getAdminOrders(afterResponse) {
        this.requestJson('getadminorders', null, afterResponse);
    }

    getPendingOrders(afterResponse) {
        this.requestJson('getpendingorders',null,afterResponse);
    }

    getAssignedTrucks(afterResponse) {
        this.requestJson("gettruckassignments", null,afterResponse);
    }

}
export default OrderService;












// getDepartmentById(id,afterResponse) {
//     this.requestJson('GetDepartmentsByLocationId', `locationId=${id}`, afterResponse);
// }